import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { BoardPage } from '../../components/BoardPage.js';
import { DEFAULT_TOP_METRICS } from '../../components/creatives/data/selection.js';
import { TopMetricsStrip } from '../../components/creatives/TopMetricsStrip.js';
import { ElementsExplorerPage } from '../../components/elements/ElementsExplorerPage.js';
import { WorkflowsFilterBar } from '../../components/filters/WorkflowsFilterBar.js';
import {
  type FilterFieldsSearch,
  filtersToScope,
  type MetricState,
  useFilterSearch,
  validateFilterSearch,
} from '../../lib/filter-search.js';
import { type MediaSearch, validateMediaSearch } from '../../lib/media-search.js';

type ElementsExplorerSearch = MediaSearch & FilterFieldsSearch & { metric?: MetricState };

function ElementsExplorerRoute() {
  const { added } = useFilterSearch('/elements-explorer');
  const [chosenTopMetrics, setChosenTopMetrics] = useState<string[]>(() => [
    ...DEFAULT_TOP_METRICS,
  ]);

  return (
    <BoardPage
      route="/elements-explorer"
      active="explore"
      topBar={({ scope, applyScope }) => (
        <WorkflowsFilterBar
          bar="elements-explorer"
          to="/elements-explorer"
          scope={scope}
          onScopeChange={applyScope}
        />
      )}
    >
      {(board) => {
        const merged = {
          ...filtersToScope(added),
          ...(board.scope.creativeType.length ? { creativeType: board.scope.creativeType } : {}),
        };
        const filters = Object.keys(merged).length ? merged : undefined;
        return (
          <>
            <TopMetricsStrip
              accountIds={board.accountIds}
              dateWindow={board.dateWindow}
              filters={filters}
              chosen={chosenTopMetrics}
              onChosenChange={setChosenTopMetrics}
              onSelectionChange={() => {}}
              leadingKpi={board.scope.leadingKpi}
              surface="elements-explorer"
            />
            <ElementsExplorerPage
              accountIds={board.accountIds}
              dateWindow={board.dateWindow}
              filters={filters}
              leadingKpi={board.scope.leadingKpi}
            />
          </>
        );
      }}
    </BoardPage>
  );
}

export const Route = createFileRoute('/elements-explorer/')({
  validateSearch: (search: Record<string, unknown>): ElementsExplorerSearch => ({
    ...validateMediaSearch(search),
    ...validateFilterSearch(search),
  }),
  component: ElementsExplorerRoute,
});
